import { ForgotPasswordOTPScreen } from "@/features/auth";

export default ForgotPasswordOTPScreen;
